import Dispatcher from "../dispatcher";

export default {
  pop() {
    Dispatcher.emit(Dispatcher.NAVIGATOR_POP);
  },
  push(route, props) {
    Dispatcher.emit(Dispatcher.NAVIGATOR_PUSH, route, props);
  },
  replaceLast(route, props, silent) {
    Dispatcher.emit(Dispatcher.NAVIGATOR_REPLACE_LAST, route, props, silent);
  },
  replace(route, props) {
    Dispatcher.emit(Dispatcher.NAVIGATOR_REPLACE, route, props);
  },
  reset() {
    Dispatcher.emit(Dispatcher.NAVIGATOR_RESET);
  }
};
